import { useAuthInitializer } from "@/hooks/useAuth";

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that initializes authentication state.
 * Must wrap any components that use auth-related hooks or ProtectedRoute.
 * @param props - Component props
 * @param props.children - Child components
 * @returns The children wrapped with auth initialization
 */
export function AuthProvider({ children }: AuthProviderProps) {
  useAuthInitializer();
  return <>{children}</>;
}
